import React from "react";
import { SvgIcon } from "@mui/material";
import PropTypes from "prop-types";

const propTypes = {
	style: PropTypes.object
};

const FacilityBlue = ({ style }) => {
	const iconStyle = style || {};
	return (
		<SvgIcon style={iconStyle}>
			<svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 31 31">
				<g id="icon-location" transform="translate(-278 -276)">
					<g id="sym-circle-line" transform="translate(278 276)">
						<g id="Path_24" data-name="Path 24" fill="#2371e5">
							<path
								d="M 14.5 28.5 C 10.76045989990234 28.5 7.244760036468506 27.04375076293945 4.600500106811523 24.39949989318848 C 1.956249952316284 21.75523948669434 0.5 18.23954010009766 0.5 14.5 C 0.5 10.76045989990234 1.956249952316284 7.244760036468506 4.600500106811523 4.600500106811523 C 7.244760036468506 1.956249952316284 10.76045989990234 0.5 14.5 0.5 C 18.23954010009766 0.5 21.75523948669434 1.956249952316284 24.39949989318848 4.600500106811523 C 27.04375076293945 7.244760036468506 28.5 10.76045989990234 28.5 14.5 C 28.5 18.23954010009766 27.04375076293945 21.75523948669434 24.39949989318848 24.39949989318848 C 21.75523948669434 27.04375076293945 18.23954010009766 28.5 14.5 28.5 Z"
								stroke="none"
							/>
							<path
								d="M 14.5 1 C 10.89402008056641 1 7.503870010375977 2.404239654541016 4.954059600830078 4.954059600830078 C 2.404239654541016 7.503870010375977 1 10.89402008056641 1 14.5 C 1 18.10597991943359 2.404239654541016 21.49612998962402 4.954059600830078 24.04594039916992 C 7.503870010375977 26.59576034545898 10.89402008056641 28 14.5 28 C 18.10597991943359 28 21.49612998962402 26.59576034545898 24.04594039916992 24.04594039916992 C 26.59576034545898 21.49612998962402 28 18.10597991943359 28 14.5 C 28 10.89402008056641 26.59576034545898 7.503870010375977 24.04594039916992 4.954059600830078 C 21.49612998962402 2.404239654541016 18.10597991943359 1 14.5 1 M 14.5 0 C 22.50812911987305 0 29 6.491870880126953 29 14.5 C 29 22.50812911987305 22.50812911987305 29 14.5 29 C 6.491870880126953 29 0 22.50812911987305 0 14.5 C 0 6.491870880126953 6.491870880126953 0 14.5 0 Z"
								stroke="none"
								fill="#fff"
							/>
						</g>
					</g>
					<g id="domain" transform="translate(285 284)">
						<path
							id="domain-2"
							data-name="domain"
							d="M14,11.667H12.5v1.444H14m0-4.333H12.5v1.444H14m1.5,4.333h-6V13.111H11V11.667H9.5V10.222H11V8.778H9.5V7.333h6M8,5.889H6.5V4.444H8M8,8.778H6.5V7.333H8m0,4.333H6.5V10.222H8m0,4.333H6.5V13.111H8M5,5.889H3.5V4.444H5M5,8.778H3.5V7.333H5m0,4.333H3.5V10.222H5m0,4.333H3.5V13.111H5M9.5,5.889V3H2V16H17V5.889Z"
							transform="translate(-2 -3)"
							fill="#fff"
						/>
					</g>
				</g>
			</svg>
		</SvgIcon>
	);
};

FacilityBlue.propTypes = propTypes;

export default FacilityBlue;
